import Cookies from "js-cookie";
import { report } from "process";

const constants = {
  client_side_storage: {
    get accessToken() {
      return Cookies.get("accessToken");
    },
    get refreshToken() {
      return Cookies.get("refreshToken");
    },
    get userDetails() {
      return JSON.parse(localStorage.getItem("userDetails") || "{}");
    },
    get selectedCategory() {
      return Cookies.get("selectedCategory");
    },
    get clientId() {
      return Cookies.get("clientId");
    },
    get expiryTime() {
      return Cookies.get("expiryTime");
    },
  },
  navigationUrls: {
    login: "/login",
    userDashboard: "/user-dashboard",
    adminDashboard: "/case-studies",
    caseStudies: "/case-studies",
    videos: "/videos",
    uploaContent: "/upload-content",
    documentDetails:"/documents-details",
    industryTrackDetails:"/industry-track-details",
    projectDetails: "/project-details",
    viewDocumentTitles: "/view-document-titles",
    viewTagProjects: "/view-tag-projects",
    viewOrgDocumentTypes: "/view-org-document_types",
    industryTrack:"/industry-track",
    certifications:"/certifications",
    queries:"/queries",
    videoDetails:"/video-details",
    users:"/users",
    reports:"/reports",
    userActivityReport:"/user-activity-report",
    industryTrackContent:"/industry-track-content",
  },
  
};

export const dislikeOptions = [
  "Not relevant to my question",
  "Make it clearer",
  "Add more details",
  "Seems incorrect",
  "Include examples / case studies",
  "Others"
];


export default constants;
